import getMultilingualAiTutorialUrl from './get-multilingual-ai-tutorial-url';
import getAiTutorialUrl from './get-ai-tutorial-url';
import getTranslateCustomCodeTutorialUrl from './get-translate-custom-code-tutorial-url';

export default {
  getAiTutorialUrl,
  getMultilingualAiTutorialUrl,
  getTranslateCustomCodeTutorialUrl,
};
